import { render, staticRenderFns } from "./StartNowButton.vue?vue&type=template&id=65e5b43e"
import script from "./StartNowButton.vue?vue&type=script&lang=js"
export * from "./StartNowButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports